import React, {Component} from 'react'

import Middleware from "../../../routes/Middleware";
import PrivateRoute from "../../../routes/PrivateRoute";
import TabComponent from "../../../components/single_components/TabComponent";
import {history} from "../../../utils/history";
import Config from "../../../config/Config";
import signedUserHelper from "../../../utils/signedUserHelper";

import ClinicsTabTools from "../../../components/clinic/ClinicsTabTools";
import AdminTabTools from "../../../components/admin/AdminsTabTools";
import AdminsTab from "./AdminsTab";
import {adminApi} from "../../../services/ApiService";

//REDUX
import { connect } from "react-redux";
import {
    setHcpData,
    filterHcpTable,
    addNewHCP,
    SETHCPsCount,

    setClinicsData,
    filterClinicsTable,
    addNewClinic,
    SETClinicsCount,


    setAdminsData,
    filterAdminsTable,
    addNewAdmin,
    SETAdminCount,
    addMediatorData,
    setMediatorData,
    SetMediatorsCount,

} from "../../../redux/actions/Tabs-Actions.js";
import {authenticationService} from "../../../services/AuthenticationService";
import Switch from "react-bootstrap/Switch";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import HCPsTabTools from "../../../components/hcp/HCPsTabTools";
import HCPsTab from "./HCPsTab";
import ClinicsTab from "./ClinicsTab";
import MediatorsTabTools from "../../../components/mediator/MediatorsTabTools";
import MediatorsTab from "./MediatorsTab";



class AdminTabsConComposed extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentUser: null,
            isHcp: false,
            isClinics: false,
            isAdmins: false,
            isMediators: false,
        }

    }

    componentWillMount() {

    }

    componentDidMount = async ()  => {
        let currentUser = authenticationService.currentUserValue;
        this.props.SETHCPsCount(currentUser.profile.NumOfHCP)
        this.props.SETClinicsCount(currentUser.profile.NumOfClinics)
        this.props.SETAdminCount(currentUser.profile.NumOfAdmins)
        this.props.SetMediatorsCount(currentUser.profile.NumOfMediators)
        this.setState({isHcp: true});

        await this.handleNavigationButton(`/dashboard/hcps`,0)
    }

    async handleNavigationButton(path,tab_id){


        let isHcp, isClinics, isAdmins,isMediators;
        if (tab_id === 0) {
            isHcp = true;
            isClinics = isAdmins  = isMediators=false;
            this.setState({isHcp, isClinics, isAdmins,isMediators})
            let hcps = await adminApi.getAllHCPs()
            if (hcps) this.props.setHcpData(hcps.data)
        } else if (tab_id === 1) {
            isClinics = true;
            isHcp  = isAdmins  =isMediators= false
            this.setState({isHcp, isClinics, isAdmins,isMediators})
            let clinics = await adminApi.getAllClinics()
            if (clinics) this.props.setClinicsData(clinics.data)
        } else if (tab_id === 2) {
            isAdmins = true
            isHcp = isClinics=isMediators  = false
            this.setState({isHcp, isClinics, isAdmins,isMediators})
            let admins = await adminApi.getAllAdmins()
            if (admins) this.props.setAdminsData(admins.data)
        } else if (tab_id === 3) {
            isMediators=true
            isHcp = isClinics  = isAdmins = false
            let mediators = await adminApi.getAllMediators()
            if (mediators) this.props.setMediatorData(mediators.data)
            this.setState({isHcp, isClinics, isAdmins,isMediators})
            // let versions = await adminApi.getAllVersions()
        }

        history.push({
            pathname: path,
            state: {
                from: {
                    fromPath: `/dashboard`,
                }
            },
        })
    }

    navLinks = () => {
        let navLinks = [];
        let {t} = this.props
        navLinks.push(Middleware.linkToDisplay(['userAccessLink'],
            <TabComponent key={'HCPs'} status={this.state.isHcp} onClick={this.handleNavigationButton.bind(this, `/dashboard/hcps`, 0)}
                          value={t('admin.hcp.hcps')} count={this.props.hcpCount}/>,
            {roles: [Config.roles.SadeSuperAdmin, Config.roles.SadeAdmin]}));
        navLinks.push(Middleware.linkToDisplay(['userAccessLink'],
            <TabComponent key={'Clinics'} status={this.state.isClinics} onClick={this.handleNavigationButton.bind(this, `/dashboard/clinics`, 1)}
                          value={t('Clinic.clinics')} count={this.props.clinicsCount}/>,
            {roles: [Config.roles.SadeSuperAdmin, Config.roles.SadeAdmin]}));
        navLinks.push(Middleware.linkToDisplay(['userAccessLink'],
            <TabComponent key={'Admins'} status={this.state.isAdmins} onClick={this.handleNavigationButton.bind(this, `/dashboard/admins`, 2)}
                          value={t('admin.admin.admins')} count={this.props.adminsCount}/>,
            {roles: [Config.roles.SadeSuperAdmin]}));
        navLinks.push(Middleware.linkToDisplay(['userAccessLink'],
            <TabComponent key={'Mediators'} status={this.state.isMediators} onClick={this.handleNavigationButton.bind(this, `/dashboard/mediators`, 3)}
                          value={"Mediators"} count={this.props.mediatorsCount}/>,
            {roles: [Config.roles.SadeSuperAdmin, Config.roles.SadeAdmin]}));

        return navLinks;
    }

    filterHcpTable(val){
        //this.render()
        this.setState({searchValue:val})
        this.props.filterHcpTable('search',val)
    }

    filterClinicsTable(val){
        //this.render()
        this.setState({searchValue:val})
        this.props.filterClinicsTable('search',val)
    }


    filterAdminsTable(val){
        //this.render()
        this.setState({searchValue:val})
        this.props.filterAdminsTable('search',val)
    }

    render() {
        return (
            <div className={'sade-context-area'}>
                <div className={'sade-table-tabs-container'}>

                    <div className={'nav'}>
                        <Switch>{this.navLinks()}</Switch>
                        {
                            this.state.isHcp
                            ? Middleware.linkToDisplay(['userAccessLink'],
                                <HCPsTabTools
                                    t={e => this.props.t(e)}
                                    filterHcpTable={val => this.filterHcpTable(val)}
                                    recipients={this.props.selectedHcpData}
                                    addNewHCP={val => this.props.addNewHCP(val)}
                                    clinicData={this.props.clinicData}
                                    isSmall={signedUserHelper.getSignedRole() === Config.roles.SadeSuperAdmin}/>,
                                {roles: [Config.roles.SadeSuperAdmin, Config.roles.SadeAdmin]})
                            : this.state.isClinics
                            ? Middleware.linkToDisplay(['userAccessLink'],
                                <ClinicsTabTools
                                    t={e => this.props.t(e)}
                                    filterClinicTable={val => this.filterClinicsTable(val)}
                                    addNewClinic={val => {
                                        this.props.addNewClinic(val)
                                    }}
                                    isSmall={signedUserHelper.getSignedRole() === Config.roles.SadeSuperAdmin}/>,
                                    {roles: [Config.roles.SadeSuperAdmin, Config.roles.SadeAdmin]})
                            : this.state.isAdmins
                            ? Middleware.linkToDisplay(['userAccessLink'],
                                <AdminTabTools
                                    t={e => this.props.t(e)}
                                    addNewAdmin={val => this.props.addNewAdmin(val)}
                                    filterAdminsTable={val => this.filterAdminsTable(val)}/>,
                                            {roles: [Config.roles.SadeSuperAdmin]})

                            :this.state.isMediators
                                            ? Middleware.linkToDisplay(['userAccessLink'],
                                                <MediatorsTabTools
                                                    addMediatorData={val => this.props.addMediatorData(val)}
                                                    t={e => this.props.t(e)}/>,
                                                {roles: [Config.roles.SadeSuperAdmin,Config.roles.SadeAdmin]})

                           :
                                            <div/>
                        }

                    </div>
                    <div className={'context-area'}>
                        <Switch>
                            <PrivateRoute exact path={`/dashboard/hcps`} component={HCPsTab}/>
                            <PrivateRoute path={`/dashboard/clinics`} component={ClinicsTab}/>
                            <PrivateRoute path={`/dashboard/admins`} component={AdminsTab}/>
                            <PrivateRoute path={`/dashboard/mediators`} component={MediatorsTab}/>

{/*
                            <PrivateRoute path={`/dashboard/versions`} component={VersionsTab}/>
*/}
                        </Switch>
                    </div>
                </div>
            </div>
        )
    }
}



function mapDispatchToProps(dispatch) {
    return {
        setHcpData: hcpData => dispatch(setHcpData(hcpData)),
        filterHcpTable:(searchType, payload) => dispatch(filterHcpTable(searchType, payload)),
        addNewHCP: hcp => dispatch(addNewHCP(hcp)),
        SETHCPsCount: count => dispatch(SETHCPsCount(count)),

        setClinicsData: clinicData => dispatch(setClinicsData(clinicData)),
        filterClinicsTable:(searchType, payload) => dispatch(filterClinicsTable(searchType, payload)),
        addNewClinic:clinic => dispatch(addNewClinic(clinic)),
        SETClinicsCount: count => dispatch(SETClinicsCount(count)),

        setAdminsData: adminData => dispatch(setAdminsData(adminData)),
        filterAdminsTable:(searchType, payload) => dispatch(filterAdminsTable(searchType, payload)),
        addNewAdmin:admin => dispatch(addNewAdmin(admin)),
        SETAdminCount: count => dispatch(SETAdminCount(count)),

        SetMediatorsCount: count => dispatch(SetMediatorsCount(count)),
        addMediatorData:mediator => dispatch(addMediatorData(mediator)),
        setMediatorData: mediatorData => dispatch(setMediatorData(mediatorData)),


    };
}
const mapStateToProps = state => {
    return {
        hcpData:state.hcpTableDataReducer.hcpData,
        hcpCount:state.hcpTableDataReducer.hcpCount,
        hcpTableFilter:state.hcpTableDataReducer.hcpTableFilter,
        selectedHcpData:state.hcpTableDataReducer.selectedHcpData,

        clinicData:state.clinicTableDataReducer.clinicData,
        clinicsCount: state.clinicTableDataReducer.clinicsCount,
        clinicTableFilter:state.clinicTableDataReducer.clinicTableFilter,

        adminData:state.adminTableDataReducer.adminData,
        adminsCount: state.adminTableDataReducer.adminsCount,
        adminTableFilter:state.adminTableDataReducer.adminTableFilter,

        mediatorsCount: state.mediatorTableDataReducer.mediatorsCount,

    };
};

const AdminTabs = compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(AdminTabsConComposed);

export default AdminTabs;
